export const ALERT_STATUS = {
    AUTOMATED: 'automated',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
} as const;

export type AlertStatus = Enum<typeof ALERT_STATUS>;

export type AlertStatusItem = {
    title: string;
    text: string;
    background?: string;
    icon: string;
};

export const ALERT_STATUS_CONFIG: Record<Exclude<AlertStatus, typeof ALERT_STATUS.AUTOMATED>, AlertStatusItem> = {
    [ALERT_STATUS.SUCCESS]: {
        title: `auth.register-tenant.success.title`,
        text: `auth.register-tenant.success.text`,
        icon: 'https://shared-assets.trustup.io/lottie/success3.json',
    },
    [ALERT_STATUS.WARNING]: {
        title: `auth.register-tenant.warning.title`,
        text: `auth.register-tenant.warning.text`,
        background: 'bg-branding-orange-light',
        icon: 'fa-solid fa-circle-exclamation text-branding-orange',
    },
    [ALERT_STATUS.ERROR]: {
        title: `auth.register-tenant.error.title`,
        text: `auth.register-tenant.error.text`,
        background: 'bg-branding-red-light',
        icon: 'fa-solid fa-circle-xmark text-branding-red',
    },
};
